document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const current = Number(input.value || 1);
        const next = button.dataset.action === 'increase' ? current + 1 : Math.max(1, current - 1);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
